<div
  class="bg-gradient-to-r from-primary to-primary/20 w-[100%] p-3 h-14 items-center flex justify-between flex-col md:flex-row"
>
  <div
    class="bg-gradient-to-r from-primary to-primary/20 p-3 flex justify-between flex-col md:flex-row"
  >
    <span class="text-white"
      >{{ getRecordRange() ? getRecordRange() :0  }} of {{ totalRecords ? totalRecords :0 }} total</span
    >
  </div>
  <div class="flex gap-4 font-bold">
    <div
      class="h-8 w-8 bg-white flex items-center justify-center rounded-sm cursor-pointer"
      (click)="onFirst()"
    >
      <img src="../../../assets/image/«.svg" alt="" />
    </div>
    <div
      class="h-8 w-8 bg-white flex items-center justify-center rounded-sm cursor-pointer"
      (click)="onPrevious()"
    >
      <img src="../../../assets/image/‹.svg" alt="" />
    </div>
    <!-- <div class="h-8 w-8 bg-white flex items-center justify-center rounded-sm" >
      <span >{{ currentPage -1}}</span>
    </div> -->
    <div class="h-8 w-8 bg-white flex items-center justify-center rounded-sm"  [class.active]="currentPage ">
      <span >{{ currentPage }}</span>
    </div>
    <div
      class="h-8 w-8 bg-white flex items-center justify-center rounded-sm cursor-pointer"
      [class.disabled]="isLastPage()"
      (click)="onNext()"
    >
      <img src="../../../assets/image/›.svg" alt="" />
    </div>
    <div
      class="h-8 w-8 bg-white flex items-center justify-center rounded-sm cursor-pointer"
      [class.disabled]="isLastPage()"
      (click)="onLast()"
    >
      <img src="../../../assets/image/».svg" alt="" />
    </div>
  </div>
</div>
